import NP from 'number-precision'
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid'
// import vconsole from 'vconsole'
// import Config from '@/api/config'
import { isPC, isHLApp, isWeiXin, isDingtalk, isTHSApp, isTHSI18NApp } from './tools'
import { CountryCodeMap, CountryCodeMapTc, CountryCodeMapEn } from '@/config/country.js'
import initI18n from '@/i18n/tools'
import { i18n } from '@/i18n/hlvip/index.js'
import { getRunEnv } from './env'
import wx from 'weixin-js-sdk'
import { JSBridge, thsI18NJsBridge } from '@fs/jsbridge'

NP.enableBoundaryChecking(false)

const $t = text => i18n.t(text)
window.logger = (...arg) => {
    if (process.env.VUE_APP_ENV !== 'prod') {
        console.log.call(null, ...arg)
    }
}

String.prototype.format = function () {
    var args = arguments
    return this.replace(/{(\d+)}/g, function (m, i) {
        return args[i] || ''
    })
}

String.prototype.toMoney = function () {
    return (
        this &&
        this.toString().replace(/\d+/, function (s) {
            return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
        })
    )
}

String.prototype.bean = function (digit = 4, sep = ' ') {
    const reg = new RegExp(`(\\d{${digit}})(?=\\d)`, 'g')
    return this.replace(reg, '$1' + sep)
}

Array.prototype.remove = function (val) {
    var index = this.indexOf(val)
    if (index > -1) {
        this.splice(index, 1)
    }
}

Date.prototype.format = function (format) {
    format = format || 'yyyy-MM-dd HH:mm:ss'
    const f = function (m) {
        return m < 10 ? `0${m}` : m
    }
    let str = format.replace('yyyy', this.getFullYear())
    str = str.replace('MM', f(this.getMonth() + 1))
    str = str.replace('dd', f(this.getDate()))
    str = str.replace('HH', f(this.getHours()))
    str = str.replace('mm', f(this.getMinutes()))
    str = str.replace('ss', f(this.getSeconds()))
    return str
}

const isMobileTerminal = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent)

// 64 位随机字符串
// const randomString = () => {
//   const str = '!@#*&%())#'
//   const date = new Date().getTime() + ''
//   const _str = md5(str + date) + md5(date)
//   return _str
// }

/**
 * 保留小数位，非四舍五入
 * @param {*} data 输入的值
 * @param {*} num   保留几位
 * @param {*} relax   可选 Boolean 不严格保留小数位数   如：输入 234.2,3,true 输出234.2 ｜ 输入234.555555,3,true 输出 234.555
 * @returns
 */
// const toFixed = function (data, num, relax) {
//   let dataLength = `${data}`.length
//   data = Number(data).toFixed(10)
//   let _digit = num ? data.lastIndexOf('.') + num + 1 : data.lastIndexOf('.')
//   if (data.lastIndexOf('.') + num + 1 < dataLength) {
//     dataLength = data.lastIndexOf('.') + num + 1
//   }
//   data = relax ? data.substring(0, dataLength) : data.substring(0, _digit)
//   return data
// }
const toFixed = function (data, num, relax) {
    let dataLength = `${data}`.length
    data = data.toString()
    if (data.lastIndexOf('.') === -1) data = data + '.000000000'
    // 整数只到10位，含小数时，整数只能是9位
    if (data.lastIndexOf('.') >= 10 && relax) return data.substring(0, 10)
    const _digit = num ? data.lastIndexOf('.') + num + 1 : data.lastIndexOf('.')
    if (data.lastIndexOf('.') + num + 1 < dataLength) {
        dataLength = data.lastIndexOf('.') + num + 1
    }
    // 补充小数位
    const dataArr = data.split('.')
    if (num && dataArr[1].length < num) {
        dataArr[1] = dataArr[1] + '000000000'
    }
    data = dataArr.join('.')
    data = relax ? data.substring(0, dataLength) : data.substring(0, _digit)
    return data
}
//部分密文显示
const ciphertext = function (value, start, end) {
    value = value + ''
    const _s = value.substring(0, start || 3)
    const _e = value.substring(value.length - end || 3, value.length)
    return `${_s}****${_e}`
}

// 密文只显示最后4位
const ciphertextLast4 = (value = '', rep = '*') => {
    let ico = '**** **** ****'
    if (rep && rep != '*') {
        ico = ico.replace(/\*/g, rep)
    }
    const sliceNum = value ? value.slice(value.length - 4, value.length) : value
    return `${ico} ${sliceNum}`
}

/**
 * //银行卡号、金额 指定分割
 * @param {*} value
 * @param {*} len 分割长度
 * @param {*} placeholder 占位符
 * 示例：637878397839 =》 6378 7839 7839
 */
const cardNumberDivision = (value = '', len = 4, placeholder = ' ') => {
    if (!value) return value
    const times = Math.ceil(value.length / len)
    const newArr = []
    for (let i = 0; i <= times; i++) {
        if (i * len >= value.length) {
            break
        }
        newArr.push(value.slice(i * len, (i + 1) * len))
    }
    return newArr.join(placeholder)
}

//获取客户端类型
const getPhonePlatform = () => {
    let _platform = 'h5'
    const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1
    if (isAndroid) {
        _platform = 'android'
    }
    const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isiOS) {
        _platform = 'ios'
    }
    return _platform
}

// 移除结尾0
const removeEndZero = function (str) {
    // str = Number(str)
    str = str.toString().split('.')
    if (str[1]) {
        str[1] = str[1].replace(/[0]+$/, '')
    }
    return str[1] && str[1].length ? str.join('.') : str.join('')
}

// 如果是 '' 默认为 0.00 显示
const defaultZero = function (value) {
    return value === '' ? '0.00' : value
}

/*倒计时
t 倒计时长，单位秒
opt 参数
callback Function 带当前倒计时时间参数回调
format  String 倒计时模板
finished Function 倒计时完毕回调执行函数
 */
const countDown = function (t, opt) {
    const format = opt.format || 'dd HH:mm:ss'
    var f = function (m) {
        return m < 10 ? '0' + m : m
    }
    function a() {
        t = Math.max(t - 1, 0)
        if (t <= 0) {
            clearInterval(interval)
            typeof opt.finished === 'function' && opt.finished()
        }
        let str = format
        str = str.replace('dd', f(Math.floor(t / (60 * 60 * 24))))
        str = str.replace('HH', f(Math.floor(t / (60 * 60))))
        str = str.replace('mm', f(Math.floor(t / 60)))
        str = str.replace('ss', f(Math.floor(t % 60)))
        if (typeof opt.callback === 'function') {
            opt.callback(str)
        }
    }
    a()
    const interval = setInterval(a, 1000)
    return interval
}

//固定显示长度不足补0
const fitLen = function (num, length) {
    num = '0'.repeat(length) + num
    return num.slice(num.length - length)
}

//检测颜色值是否为亮色
const isLightColor = function (hexString) {
    if (hexString.charAt(0) !== '#') {
        hexString = '#' + hexString
    }
    if (hexString.length === 4) {
        const split = hexString.split('')
        hexString = '#' + split[1] + split[1] + split[2] + split[2] + split[3] + split[3]
    }

    hexString = hexString.substring(hexString.length - 6, hexString.length)
    const _r = parseInt('0x' + hexString.slice(0, 2))
    const _g = parseInt('0x' + hexString.slice(2, 4))
    const _b = parseInt('0x' + hexString.slice(4, 6))
    const _light = _r * 0.299 + _g * 0.587 + _b * 0.114
    return _light >= 192 ? true : false
}

// 数字人性化显示
const humanNum = function (number, digit = 2, i18n) {
    try {
        const _n = parseFloat(number)
        let rst,
            unit = ''
        if (_n / 100000000 > 1) {
            rst = _n / 100000000
            unit = i18n ? i18n.t('亿') : '亿'
        } else if (_n / 10000 > 1) {
            rst = _n / 10000
            unit = i18n ? i18n.t('万') : '万'
        } else {
            rst = _n
        }
        return toFixed(rst, digit) + unit
    } catch (e) {
        return number
    }
}

//时间格式人性化
const humanTime = function (msec, options = {}) {
    const { minutesLen = 2 } = options

    var days = parseInt(msec / 1000 / 60 / 60 / 24, 10) //计算剩余的天数
    var hours = parseInt((msec / 1000 / 60 / 60) % 24, 10) //计算剩余的小时
    var minutes = parseInt((msec / 1000 / 60) % 60, 10) //计算剩余的分钟
    var second = parseInt((msec / 1000) % 60, 10) //计算剩余的分钟
    days = fitLen(days, 2)
    hours = fitLen(hours, 2)
    minutes = fitLen(minutes, minutesLen)
    second = fitLen(second, 2)
    return { days, hours, minutes, second }
}

//判断是否为空对象、空数组
const isEmpty = function (obj) {
    //检验null和undefined
    if (!obj && obj !== 0 && obj !== '') {
        return true
    }
    //检验数组
    if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
        return true
    }
    //检验对象
    if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
        return true
    }
    return false
}

/**
 * 如果target(也就是FirstOBJ[key])存在，
 * 且是对象的话再去调用deepObjectMerge，
 * 否则就是FirstOBJ[key]里面没这个对象，需要与SecondOBJ[key]合并
 */
const deepObjectMerge = function (FirstOBJ, SecondOBJ) {
    // 深度合并对象
    for (const key in SecondOBJ) {
        FirstOBJ[key] =
            FirstOBJ[key] && FirstOBJ[key].toString() === '[object Object]'
                ? deepObjectMerge(FirstOBJ[key], SecondOBJ[key])
                : (FirstOBJ[key] = SecondOBJ[key])
    }
    return FirstOBJ
}

// 函数防抖：
/**
 * 防抖函数的用法，这里需要注意this 的指向，一定要先申明，形成闭包，否则防抖无效
 *
 * 执行 debounce 函数返回新函数
 * const betterFn = debounce(() => console.log('fn 防抖执行了'), 1000)
 * 停止滑动 1 秒后执行函数 () => console.log('fn 防抖执行了')
 * document.addEventListener('scroll', betterFn)
 */
const debounce = function (fn, wait = 50) {
    let timer = null
    return function () {
        const self = this
        if (timer) {
            clearTimeout(timer)
            timer = null
        }
        timer = setTimeout(function () {
            fn.apply(self, arguments)
        }, wait)
    }
}

// 函数节流
const throttle = function (fn, gapTime) {
    let _lastTime = null
    return function () {
        const self = this
        const _nowTime = +new Date()
        if (_nowTime - _lastTime > gapTime || !_lastTime) {
            fn.apply(self, arguments)
            _lastTime = _nowTime
        }
    }
}

/*
连按五次打开\关闭调试
@skip 是否跳过5次点击动作直接显示调试器
 */
// let vConsole = null,
//     vi = 0
const toggleDebug = function (skip) {
    // vi++
    // if (vi % 5 === 0 || skip) {
    //     if (vConsole) {
    //         vConsole.destroy()
    //         vConsole = null
    //     } else {
    //         vConsole = new vconsole()
    //     }
    // }
}

//兼容H5 与App 打开网址或pdf文件
// const openURL = ({url='', title='', text='', navbar=true}={}, newWindow=false)=>{
//   const pdfBase = 'https://m.youyu.cn/c/hybrid/pdf/'
//   const htmlBase = 'https://m.youyu.cn/c/hybrid/html/'
//   const BaseUrl = {pdf:pdfBase, html:htmlBase}
//   const type = text?'text':(url.toLowerCase().includes('.pdf')?'pdf':'html')
//   let path = url.includes('http')?url:BaseUrl[type]+url
//   if(type=='text'){
//     VM.$router.push({name:'iframe', params:{title, text}})
//   } else {
//     if(Bridge.isInApp){
//       if(type=='pdf'){
//         Bridge.previewDocument({
//           url: path,
//           title,
//           type,
//         })
//       } else {
//         Bridge.jumpWithPrivateURL({
//           url:`yystock://webView?url=${encodeURIComponent(path)}`
//         })
//       }
//     } else {
//       if(type=='pdf'){
//         window.open(path)
//       } else {
//         if(newWindow){
//           window.open(path)
//         } else {
//           VM.$router.push({name:'iframe', params:{title, url:path, navbar}})
//         }
//       }
//     }
//   }

// }

//调用腾讯云滑块验证
// const captchaQQ = callback=>{
//   const captcha_qq = new TencentCaptcha('2040163076', res=>{
//     callback && callback(res)
//   }, {
//     enableDarkMode: localStorage.getItem('theme')=='dark'?'force':false,
//     needFeedBack:false
//   })
//   return captcha_qq
// }

//密码设置规则验证，密码长度8-20位且至少包含大写字母、小写字母、数字或特殊符号中的任意三种
const isPassword = val => {
    const reg = new RegExp('^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{8,20}$')
    return reg.test(val)
}

/**
 * 转换公私钥为标准pem格式
 * @param {string} str
 * @returns string
 */
const formatAsPem = str => {
    var typeString = 'PUBLIC KEY'
    var finalString = '-----BEGIN ' + typeString + '-----\n'
    while (str.length > 0) {
        finalString += str.substring(0, 64) + '\n'
        str = str.substring(64)
    }
    finalString = finalString + '-----END ' + typeString + '-----'
    return finalString
}

/**
 * 创建uuid5
 * @param {string} uin
 * @returns string
 */
const generateUUID = (uin = '') => {
    return uuidv5(uin + new Date().valueOf() + '', uuidv4())
        .split('-')
        .join('')
}

const blobToDataURL = blob => {
    return new Promise(resolve => {
        const a = new FileReader()
        a.onload = function (e) {
            resolve(e.target.result)
        }
        a.readAsDataURL(blob)
    })
}

// 是否竖屏
const isPortrait = () => {
    const width = document.documentElement.clientWidth
    const height = document.documentElement.clientHeight
    return width < height
}

// 是否横屏
const isLandscape = () => {
    const width = document.documentElement.clientWidth
    const height = document.documentElement.clientHeight
    return width >= height
}

const dataURLtoBlob = (dataurl, { toFile = false, filename = 'unknown', type = 'image/jpeg' }) => {
    // 获取到base64编码
    const arr = dataurl.split(',')
    // 将base64编码转为字符串
    const bstr = window.atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    if (toFile) {
        return new File([u8arr], filename, {
            type,
        })
    }
    return new Blob([u8arr], {
        type,
    })
}
/**
 * 获取指定长度的字符串(数字+字母)
 * @param n 长度
 * @returns 字符串
 */
const getRndStr = (n, ishex = false) => {
    let str = ''
    // 若是16进制，则取前6个字母
    const letterNum = ishex ? 6 : 26
    const total = ishex ? 22 : 62
    const upperNum = ishex ? 16 : 36
    for (let i = 0; i < n; i++) {
        const tmp = Math.floor(Math.random() * total)
        if (tmp < 10) {
            // 数字
            str += Math.floor(Math.random() * 10)
        } else if (tmp < upperNum) {
            // 大写字母
            str += String.fromCharCode(Math.floor(65 + Math.random() * letterNum))
        } else {
            // 小写字母
            str += String.fromCharCode(Math.floor(97 + Math.random() * letterNum))
        }
    }
    return str
}

// 兼容window.open
const openUrl = (url = '', fileName = '') => {
    if (isPC()) {
        window.open(url)
    } else {
        const a = document.createElement('a')
        a.href = url
        if (fileName) {
            a.download = fileName
        }
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }
}

const openPDF = (url = '', title = '', isOssFile = false) => {
    if (JSBridge) {
        JSBridge.openPDF({
            url: encodeURIComponent(url),
            title: title,
            type: isOssFile ? 1 : 0,
        })
    } else if (thsI18NJsBridge.isTHSI18NApp()) {
        thsI18NJsBridge.openPDF({
            url: url,
            title: title,
        })
    } else if (isTHSApp() && getPhonePlatform() === 'android') {
        callNativeHandler(
            'HXDownloadFile',
            JSON.stringify({
                url: url,
                filetype: 'pdf',
                title: title,
            }),
            () => {}
        )
    } else {
        openUrl(url, title)
    }
}

// 清除登录信息
const clearLoginInfo = () => {
    localStorage.removeItem('session')
    localStorage.removeItem('uin')
}

/** 针对中文字即其它添加空格的间隔，数字不加空格
 * 示例：你好1234加空格abd c字母不带空格  =>  你 好 1234 加 空 格 abd c 字 母 不 带 空 格
 */
const ChineseSpace = text => {
    let callbackText = ''
    if (text) {
        const textArr = text.split('')

        let contentType = 0 // 1:文字  2:字母   3:数字
        textArr.map(item => {
            if (/^[a-zA-Z\s]/.test(item)) {
                // 字母
                if (contentType == 2) {
                    callbackText = `${callbackText}${item}`
                } else {
                    callbackText = `${callbackText} ${item}`
                }
                contentType = 2
            } else if (/^[0-9\s]/.test(item)) {
                // 数字
                if (contentType == 3) {
                    callbackText = `${callbackText}${item}`
                } else {
                    callbackText = `${callbackText} ${item}`
                }
                contentType = 3
            } else {
                // 其它，中文字
                callbackText = `${callbackText} ${item}`
                contentType = 1
            }
        })
    }
    return callbackText ? callbackText : text
}

/**
 * 跳转页面
 * @param {*} url 必选参数，要跳转的页面地址
 */
const openPage = url => {
    const link = getTimestampUrl(url)
    window.open(link, '_blank')
}

//替换路由
const replacePage = url => {
    const link = getTimestampUrl(url)
    window.location.replace(link)
}

/**
 * 网址追加时间戳
 * @param {*} url 必选参数，页面地址
 */
const getTimestampUrl = (url = '') => {
    let link = decodeURIComponent(url)
    const time = +new Date()
    const queStr = '?'
    const hashStr = '#/'
    const reg = new RegExp('[?&]t=([^&]+)', 'i')
    const isHashMode = link.indexOf(hashStr) > -1
    if (isHashMode) {
        // hash模式
        const hashPrefix = link.split(hashStr)[0]
        const hasTimeStamp = hashPrefix.match(reg)
        // 网址本身有时间戳,直接返回
        if (hasTimeStamp) return link
        const queIndex = hashPrefix.indexOf(queStr)
        if (queIndex > -1) {
            link = insertStr(link, queIndex + 1, `t=${time}&`)
        } else {
            const hashIndex = link.indexOf(hashStr)
            link = insertStr(link, hashIndex, `?t=${time}`)
        }
    } else {
        // history模式
        const hasTimeStamp = link.match(reg)
        if (hasTimeStamp) return link
        const queIndex = link.indexOf(queStr)
        link = queIndex > -1 ? insertStr(link, queIndex + 1, `t=${time}&`) : `${link}?t=${time}`
    }
    return link
}

/**
 * 字符串指定位置添加元素
 * @param str1:原字符串
 * @param n:插入位置
 * @param str2:插入元素
 * @return  拼接后的字符串
 */
const insertStr = (str1, n, str2) => {
    var s1 = ''
    var s2 = ''
    if (str1.length < n) {
        return str1 + str2
    }
    s1 = str1.substring(0, n)
    s2 = str1.substring(n, str1.length)
    return s1 + str2 + s2
}

/**
 * 跳转页面还是替换页面
 * @param {*} url 必选参数，要跳转的页面地址
 * @param {*} replace 可选参数，默认不替换
 */
const goPage = (url, replace = false) => {
    replace ? replacePage(url) : openPage(url)
}

const getCountryCodeMap = (locale) => {
    const langType = locale || initI18n().locale
    if (langType == 'zhTc' || langType == 'zhTw') {
        return CountryCodeMapTc
    } else if (langType == 'zhCn') {
        return CountryCodeMap
    } else if (langType == 'en' || langType == 'enUs') {
        return CountryCodeMapEn
    }
    return CountryCodeMap
}

//时间格式转换
function returnDiyDate(date) {
    var result = ''
    var currentYear = new Date().getFullYear()
    var tYear = new Date(date).getFullYear()
    var tTime = new Date(new Date().setHours(0, 0, 0, 0)) //当天凌晨时间
    var eTime = 24 * 60 * 60 * 1000 //一天时间
    var yTime = tTime - eTime //昨天凌晨时间
    var byTime = tTime - 2 * eTime //前天凌晨时间
    var formatDate = new Date(date).format('HH:mm') //转成时分格式
    if (date >= tTime) {
        //今天
        result = '今天 ' + formatDate
    } else if (date < tTime && date >= yTime) {
        //昨天
        result = '昨天 ' + formatDate
    } else if (date < yTime && date >= byTime) {
        //前天
        result = '前天 ' + formatDate
    } else if (tYear == currentYear) {
        //本年度
        result = new Date(date).format('MM/dd HH:mm')
    } else {
        result = new Date(date).format('yyyy/MM/dd HH:mm')
    }
    return result
}

// 获取请求baseUrl
const getBaseUrl = (baseUrl = '', localProxy = false) => {
    return (isHLApp() && !localProxy) || process.env.NODE_ENV === 'production' ? baseUrl : ''
}

export const isProd = () => {
    return process.env.VUE_APP_ENV === 'prod'
}

export const hiddenVConsole = () => {
    if (isProd()) return
    const vconsole = document.getElementById('__vconsole')
    vconsole.style.display = 'none'
}

// 微信音频Audio兼容处理
const wxAudioHack = audioDom => {
    if (audioDom) {
        setTimeout(() => {
            audioDom.muted = true
            const playResult = audioDom.play()
            if (playResult && typeof playResult.catch === 'function') {
                playResult.catch(err => console.log('自动播放err: ', err))
            }
            audioDom.pause()
            audioDom.muted = false
        }, 100)
    }
}

/**
 * @name 对比app版本号
 * @param { String } preVersion
 * @param { String } lastVersion
 * @returns -1: v1 < v2; 0: v1 === v2; 1: v1 > v2；
 */
export function compareVersion(preVersion = '', lastVersion = '') {
    const moreThan = 1 // 大于
    const equal = 0 // 等于
    const lessThan = -1 // 小于
    const preList = preVersion.split('.')
    const lastList = lastVersion.split('.')
    let result
    const lng = Math.max(preList.length, lastList.length)
    for (let i = 0; i < lng; i++) {
        const pre = preList[i] ? Number(preList[i]) : 0
        const last = lastList[i] ? Number(lastList[i]) : 0
        if (pre > last) {
            result = moreThan
            break
        } else if (pre < last) {
            result = lessThan
            break
        }
        result = equal
    }
    return result
}

//阅读量显示规则处理
export function getReadingNums(nums = 0) {
    let result = 0
    if (nums < 10000) {
        result = nums + ''
    } else if ((nums >= 10000) & (nums <= 100000)) {
        if (keepDecimals(nums / 10000, 1).split('.')[1] > 0) {
            result = keepDecimals(nums / 10000, 1) + $t('万')
        } else {
            result = keepDecimals(nums / 10000, 0) + $t('万')
        }
    } else {
        result = `10${$t('万')}+`
    }
    return result
}

/**
 * @name 四舍五入
 * @param Number val 数字
 * @param Number places 保留位数
 * @return String
 */
export const keepDecimals = (val, places) => {
    let num = val + ''
    if (places > 0) {
        num = NP.round(val, places) + ''
        const numStart = num.split('.')[0]
        const numEnd = num.split('.')[1] || ''
        num = `${numStart}.${numEnd.padEnd(places, '0')}`
    } else {
        num = Math.round(num)
    }
    return num
}

// 关闭页面
const closePage = () => {
    if (JSBridge) {
        JSBridge.close()
    } else if (isWeiXin()) {
        wx.closeWindow()
    } else if (isDingtalk()) {
        import('dingtalk-jsapi').then(dd => {
            dd.ready(function () {
                dd.biz.navigation.close({
                    onSuccess: function () {},
                    onFail: function () {},
                })
            })
        })
    } else if (isTHSApp()) {
        callNativeHandler('goback', { type: 'component' })
    } else if (isTHSI18NApp()) {
        thsI18NJsBridge.closeWebPage()
    } else {
        window.location.href = 'about:blank'
        window.close()
    }
}
export const addCurParamsForUrl = (url = '', options = {}) => {
    options = Object.assign({}, { needAddProtocol: true }, options)
    const getUrlQuerys = (url = '') => {
        const reg = /\?([^?#])+/g
        const queryStrings = []
        const matchs = url.match(reg) || []
        matchs.reduce((o, str) => {
            str = str.replace(/^\?/, '')
            str.split('&').forEach(i => {
                const res = i.split('=')
                o.push(res)
            })
            return o
        }, queryStrings)
        return queryStrings
    }

    const addQuerys = (url = '', querys) => {
        const newQuerys = getUrlQuerys(url)
        const resObj = {}
        const querysList = [...querys, ...newQuerys]
        querysList.forEach(([k, v]) => {
            resObj[k] = v
        })

        querys = Object.entries(resObj)
        let queryString = querys.reduce((str, [k, v]) => ((str += `${k}=${v}&`), str), '').replace(/&$/, '')
        if (!queryString) return url

        queryString = '?' + queryString
        if (/\?/.test(url)) {
            const end = url.indexOf('?')
            url = url.slice(0, end)
        }

        return `${url}${queryString}`
    }

    const urlQuerys = getUrlQuerys(location.href)
    if (options.needAddProtocol) {
        if (!/^http(s?)/.test(url)) {
            url = `${location.origin}${url}`
        }
    }
    return addQuerys(url, urlQuerys)
}

/**
 * @name 计算rem
 * @param Number num
 * @param Object option
 */
const calcRem = (document, value) => {
    const fontSize = document.documentElement.style.fontSize.replace('px', '')
    return NP.times(NP.divide(value, 100), fontSize)
}

export const getColorClass = (v, reverse = false) => {
    const num = Number(v)
    if (num > 0) {
        return reverse ? 'fall' : 'rise'
    } else if (num < 0) {
        return reverse ? 'rise' : 'fall'
    }

    return 'flat'
}

export function getUserAgent(key) {
    const arr = window.navigator.userAgent.split(' ')
    const obj = {}
    arr.forEach(item => {
        if (item.indexOf('/') > 0) {
            const _arr = item.split('/')
            obj[_arr[0]] = _arr[1]
        }
    })
    return obj[key]
}

export const drawWithClosure = (ctx, func) => {
    ctx.save()
    ctx.beginPath()
    func()
    ctx.stroke()
    // #ifdef H5
    if (ctx.draw) {
        ctx.draw(true)
    }
    // #endif
    ctx.restore()
}

/**
 * 从URL中移除指定参数
 * @param {string} url - 原始URL
 * @param {string} paramName - 要移除的参数名
 * @returns {string} 移除参数后的URL，如果出现异常则返回原URL
 */
export const removeUrlParam = (url, paramName) => {
    try {
        // 参数验证
        if (!url || typeof url !== 'string' || !paramName || typeof paramName !== 'string') {
            return url || ''
        }

        // 转义正则表达式特殊字符，避免正则表达式错误
        const escapedParamName = paramName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

        // 首先检查URL中是否包含要移除的参数，如果不包含则直接返回原URL
        const paramPattern = new RegExp(`[?&]${escapedParamName}=`, 'g')
        if (!paramPattern.test(url)) {
            return url
        }

        // 处理包含hash路由的URL
        if (url.includes('#/')) {
            const [baseUrl, hashPart] = url.split('#/')

            // 处理hash部分中的查询参数
            if (hashPart && hashPart.includes('?')) {
                const [hashPath, hashQuery] = hashPart.split('?')
                const hashParams = new URLSearchParams(hashQuery)
                hashParams.delete(paramName)

                // 重新构建hash部分
                const newHashQuery = hashParams.toString()
                const newHashPart = newHashQuery ? `${hashPath}?${newHashQuery}` : hashPath

                return `${baseUrl}#/${newHashPart}`
            }
            // hash部分没有查询参数，直接返回原URL
            return url
        }
        // 处理普通URL（没有hash路由）
        // 检查是否为完整URL（包含协议）
        if (url.startsWith('http://') || url.startsWith('https://')) {
            // 完整URL，直接使用
            const urlObj = new URL(url)
            urlObj.searchParams.delete(paramName)
            return urlObj.toString()
        }
        // 相对URL，需要base URL
        const baseUrl = typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : 'http://localhost'

        const urlObj = new URL(url, baseUrl)
        urlObj.searchParams.delete(paramName)
        return urlObj.toString()
    } catch (error) {
        return url
    }
}

/**
 * 合并 URL 的 Query 和 Hash 参数，生成新 URL
 * @param {string} urlStr - 原始 URL（默认当前页面 URL）
 * @param {Object} newQueryParams - 要合并的 Query 参数（? 后面的部分）
 * @param {Object} newHashParams - 要合并的 Hash 参数（# 后面的部分）
 * @returns {string} 合并后的新 URL
 */
function mergeUrlParams(urlStr = window.location.href, newQueryParams = {}, newHashParams = {}) {
    const url = new URL(urlStr)

    // 1. 合并 Query 参数（? 后面的部分）
    const queryParams = new URLSearchParams(url.search)
    Object.entries(newQueryParams).forEach(([key, value]) => {
        queryParams.set(key, value)
    })
    url.search = queryParams.toString()

    // 2. 合并 Hash 参数（# 后面的部分）
    const hash = url.hash
    if (hash.includes('?')) {
        // 如果 Hash 已有参数（如 #/?id=123）
        const [hashPath, hashQuery] = hash.split('?')
        const hashParams = new URLSearchParams(hashQuery)
        Object.entries(newHashParams).forEach(([key, value]) => {
            hashParams.set(key, value)
        })
        url.hash = `${hashPath}?${hashParams.toString()}`
    } else if (Object.keys(newHashParams).length > 0) {
        // 如果 Hash 无参数，但需要新增
        const hashParams = new URLSearchParams()
        Object.entries(newHashParams).forEach(([key, value]) => {
            hashParams.set(key, value)
        })
        url.hash = `${hash}?${hashParams.toString()}`
    }

    return url.toString()
}

export {
    calcRem,
    isMobileTerminal,
    goPage,
    toFixed,
    defaultZero,
    ciphertext,
    ciphertextLast4,
    cardNumberDivision,
    getPhonePlatform,
    removeEndZero,
    countDown,
    fitLen,
    isLightColor,
    // randomString,
    humanNum,
    humanTime,
    isEmpty,
    deepObjectMerge,
    debounce,
    throttle,
    toggleDebug,
    openUrl,
    openPDF,
    // captchaQQ,
    isPassword,
    formatAsPem,
    generateUUID,
    blobToDataURL,
    isPortrait,
    isLandscape,
    dataURLtoBlob,
    getRndStr,
    clearLoginInfo,
    ChineseSpace,
    getCountryCodeMap,
    returnDiyDate,
    getBaseUrl,
    wxAudioHack,
    closePage,
    mergeUrlParams,
}
